// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".google-captcha-policy[data-v-47533c3c]{margin-bottom:21px;font-size:11px;line-height:12px}", ""]);
// Exports
module.exports = exports;
